// ink-component
import React from 'react';
import styled from 'styled-components';

import resets from '../../assets/styled/resets';
import { colorTokens } from '../../tokens/globals/tokens';
import Dialog from '../../components/Dialog/Dialog';
import Icon from '../../components/Icon/Icon';

import SpreadsheetV2, { SpreadsheetV2Props } from '../SpreadsheetV2/SpreadsheetV2';
import { SpreadsheetWrapper } from '../SpreadsheetV2/components';
import { SpreadsheetTableWrapper } from '../SpreadsheetV2/components/SpreadsheetTableWrapper';
import { SpreadsheetSliderTabButton } from '../SpreadsheetV2/components/SpreadsheetSlider/slider-components';

const FullPageSpreadsheetWrapper = styled(SpreadsheetWrapper)`
  height: 100%;

  ${SpreadsheetTableWrapper} {
    height: calc(100vh - 61px);
  }
`;

const FullPageSpreadsheetV2CloseButtonWrapper = styled.div`
  ${resets.BrowserButton}
  background-color: ${colorTokens.GlobalBrandWhite};
  color: ${colorTokens.GlobalBrandGray80};
  border-left: 1px solid ${colorTokens.GlobalBrandGray40};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: -20px;
  width: 60px;
  height: 40px;
`;

export interface FullPageSpreadsheetV2Props extends SpreadsheetV2Props {
  /** Defines the callback called when a user clicks the `x` icon to close the FullPageSpreadsheet.  */
  onCloseClick: () => void;
}

/**
 * @purpose Provide users with a full page spreadsheet experience
 * @categories spreadsheet
 * @status beta
 */

const FullPageSpreadsheetV2 = (props: FullPageSpreadsheetV2Props) => {
  return (
    <Dialog>
      <FullPageSpreadsheetWrapper>
        <SpreadsheetV2
          {...props}
          menu={callbacks => (
            <>
              {props.menu && props.menu(callbacks)}
              <FullPageSpreadsheetV2CloseButtonWrapper>
                <SpreadsheetSliderTabButton onClick={props.onCloseClick}>
                  <Icon type="close" size="xxl" meaning="close" />
                </SpreadsheetSliderTabButton>
              </FullPageSpreadsheetV2CloseButtonWrapper>
            </>
          )}
          height="tall"
        />
      </FullPageSpreadsheetWrapper>
    </Dialog>
  );
};

FullPageSpreadsheetV2.displayName = 'FullPageSpreadsheetV2';

export default FullPageSpreadsheetV2;
